module.exports = __webpack_public_path__ + "static/media/qr.1eea8539.png";